<div class="relative flex flex-col sm:flex-row items-center gap-8 sm:gap-6 px-6 pt-14 pb-10 sm:py-16 bg-gradient-to-br from-[#eef3f8] via-[#f3f7f6] to-[#e9f5e4]">
  <img class="w-[170px] sm:w-[180px] shrink-0 block mix-blend-multiply" src="assets/img/app-logo.jpg" alt="AVANA CUSO">

  <button class="relative flex-1 w-full rounded-lg overflow-hidden border-2 border-white shadow-lg cursor-pointer"
    aria-label="Watch the video" (click)="watchVideo()">
    <img class="w-full aspect-video object-cover block" src="assets/img/welcome-video.svg" alt="">
    <span class="absolute left-2 bottom-2 flex items-center justify-center w-9 h-9 rounded-full bg-white shadow">
      <i class="material-symbols-rounded text-Gray-1000">play_arrow</i>
    </span>
    <span class="absolute right-2 bottom-2 px-1.5 py-0.5 rounded bg-Gray-1000/70 text-white text-sm">1:44</span>
  </button>

  <button class="absolute top-4 right-4 flex items-center justify-center w-8 h-8 rounded-full cursor-pointer text-Gray-1000 hover:bg-Gray-400/50"
    aria-label="Close" (click)="close()">
    <i class="material-symbols-rounded">close</i>
  </button>
</div>

<div class="flex flex-col p-4 sm:p-6">
  <p class="text-sm text-Gray-800">Video · under 2 minutes</p>
  <p class="text-xl font-bold mt-3">Welcome to AVANA CUSO{{ firstName() ? ', ' + firstName() : '' }}</p>
  <p class="text-base text-Gray-800 mt-2">This is where {{ creditUnionName() }} finds loan participations, registers interest and follows every deal through to funding. Watch a short video to see how it all works.</p>

  <div class="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-between gap-4 mt-8">
    <button class="text-brand cursor-pointer hover:underline" (click)="dontShowAgain()">Don't show again</button>

    <div class="flex flex-col-reverse sm:flex-row gap-2">
      <button class="secondary-btn" (click)="skip()">Skip for now</button>
      <button class="main-btn" (click)="watchVideo()">Watch the video</button>
    </div>
  </div>
</div>
